query GetAllIssues(
	$offset: Int!
	$limit: Int!
	$sort: core_label_issuesSort
	$daysFilter: ConditionInt
	$severityFilter: ConditionString
	$issueTypeFilter: ConditionString
	$environmentFilter: ConditionString
	$businessUnitFilter: ConditionString
	$textSearch: core_label_issuesSearchInsensitive
) {
	core_label_issues(
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysFilter
		severity_name_eq: $severityFilter
		type_name_eq: $issueTypeFilter
		environment_eq: $environmentFilter
		business_unit_eq: $businessUnitFilter
		text_contains: $textSearch
	) {
		issue_id
		run_id
		product_name
		type_name
		severity_name
		page_title
		url
		session_name
		user_name
		business_unit
		environment
	}
	total: core_label_issues(
		run_time_last_n_days: $daysFilter
		severity_name_eq: $severityFilter
		type_name_eq: $issueTypeFilter
		environment_eq: $environmentFilter
		business_unit_eq: $businessUnitFilter
		text_contains: $textSearch
	) {
		issue_id_count
	}
	unfilteredTotal: core_label_issues {
		issue_id_count
	}
}
